import type { GetGoodestFindsResponse } from './goodest-finds'

export const getGoodestFindsMock: GetGoodestFindsResponse = {
  title: 'Our goodest finds',
  buttons: [
    {
      label: 'Lowest price',
      icon: 'IconEyes',
      image: 'IllustrationMoneyBagz',
      paragraphs: [
        {
          title: 'Lowest price',
          text: 'This is the lowest price for the iPhone 12 Pro we have today.',
        },
        {
          title: 'Not good enough?',
          text: 'Download our app and set up alerts to know when prices drop.',
          linkToApp: true,
        },
      ],
    },
    {
      label: 'Top shelf',
      icon: 'IconSparkles',
      image: 'IllustrationMoneyBagzSparkles',
      paragraphs: [
        {
          title: 'Top shelf',
          text: 'This is the lowest price for the iPhone 12 Pro in excellent condition with the highest storage capacity.',
        },
        {
          title: 'Not good enough?',
          text: 'Download our app and set up alerts to know when prices drop.',
          linkToApp: true,
        },
      ],
    },
  ],
}
